// ** Logo
import logo from '@src/assets/images/icons/RILAC-Logo.svg'
import logo1 from '@src/assets/images/icons/zainLogo.svg'

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner vh-100'>
      <img className='fallback-logo' width='150px' src={logo1} alt='logo' />
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
